(function () {
  function flipCard(event) {
    const card = event.target.closest(".cav-flip-card-item");
    console.log(card);
    card.classList.toggle("is-flipped");
    card.style.transform =
      card.style.transform === "rotateY(180deg)"
        ? "rotateY(0deg)"
        : "rotateY(180deg)";
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".cav-flip-cards[data-variant]")
      .forEach((cardBlock) => {
        var max = 0;
        const flipCards = cardBlock.querySelectorAll(".cav-flip-card-item");

        flipCards.forEach((card) => {
          card.addEventListener("click", flipCard);

          var cardFront = card.querySelector('[class*="__front"]');
          var cardBack = card.querySelector('[class*="__back"]');

          cardFront.style.height = "initial";
          cardFront.style.position = "relative";
          cardBack.style.height = "initial";

          var cfh = cardFront.getBoundingClientRect().height;
          var cbh = cardBack.getBoundingClientRect().height;

          if (cfh > max) {
            max = cfh;
          }

          if (cbh > max) {
            max = cbh;
          }
        });

        flipCards.forEach((card) => {
          var cardFront = card.querySelector('[class*="__front"]');
          var cardBack = card.querySelector('[class*="__back"]');

          cardFront.style.height = "";
          cardFront.style.position = "";
          cardBack.style.height = "";

          // card.style.minHeight = max + "px";
        });
      });
  });
})();
